var MediaQueries = function (gal) {
    var _this = this,
        scrollOpenFlag = true,
        relatedWidthPanel = 200;
        relatedWidth = (dom.getById('navigation') ? dom.getById('navigation').clientWidth : 0) + (dom.getById('related') ? dom.getById('related').clientWidth : 0),
        _isRedesign = $('.vr-slider-body').length > 0;


    function _init() {
        var debouncedSwitchToSingle = dom.debounce(function(){
            if (gal.currentState.mode === ViewConsts.double) {
                gal.switchToSingleMode();
            }
        }, 0);

        // var debouncedSwitchToDouble = dom.debounce(function(){
        //     if (gal.currentState.defaultMode === ViewConsts.double && gal.currentState.mode === ViewConsts.single) {
        //         gal.switchToDoubleMode();
        //     }
        // }, 0);

        var scrollOpenFlag = isMobile === false ? relatedScroll.isScrollOpen() : false;

        var minFrontCoverW = 346,
            minFrontCoverH = 400,
            minBackCoverW = 310,
            minBackCoverH = 400;

        var _debouncedMediaResize = dom.debounce(function(e) {
            var scrollWrapBounds = document.querySelector('.pswp__scroll-wrap').getBoundingClientRect(),
                imgPage = gal.gallery.currItem.container.querySelector('.page-1 .slide-img'),
                imgPageBounds,
                isScrollOpen = relatedScroll.isScrollOpen(),
                $centerBanner = $('.view-banner-top').length ? $('.view-banner-top') : $('.view-banner-bottom');

            if(gal.isAtStart() === false){
                // imgPage = gal.gallery.currItem.container.querySelector('.page-0');
            }
            
            imgPageBounds = imgPage ? imgPage.getBoundingClientRect() : {};

            if(gal.currentState.mode === ViewConsts.single){
                if(gal.jsonData.type === ViewConsts.xml && !gal.gallery.currItem.additional_page){
                    imgPageBounds = gal.gallery.currItem.container.querySelector('.html-slide').getBoundingClientRect();
                }else{
                    imgPageBounds = gal.gallery.currItem.container.querySelector('IMG').getBoundingClientRect();
                }
            }

            if($centerBanner.length && scrollWrapBounds.left > $centerBanner[0].getBoundingClientRect().left && isScrollOpen){
                if(_isRedesign === false){
                    relatedScroll.scrollClose();
                }
            }

            if(gal.currentState.defaultMode === ViewConsts.double){

                if(gal.currentState.mode === ViewConsts.double){
                    if(scrollWrapBounds.width / 2 < minFrontCoverW || scrollWrapBounds.height < minFrontCoverH){

                        if(_isRedesign){
                            relatedWidthPanel = 0;
                        }

                        if(scrollWrapBounds.width / 2 + relatedWidthPanel > minFrontCoverW && isScrollOpen && scrollWrapBounds.height >= minFrontCoverH){
                            if(_isRedesign === false){
                                relatedScroll.scrollClose();
                            }
                        }else{
                            debouncedSwitchToSingle();
                        }
                    }
                }else if(gal.currentState.mode === ViewConsts.single){

                    // if(scrollWrapBounds.width / 2 >= minFrontCoverW && scrollWrapBounds.height >= minFrontCoverH){
                    //     debouncedSwitchToDouble();
                    // }
                }
            }
        }, 100);

        if(isMobile === false){
            _debouncedMediaResize();

            window.addEventListener('resize', _debouncedMediaResize);
        }

        setTimeout(function(){
            $('#view-main-wrapper').addClass('inited');
            
            /* load zones after inital zoom in end */
            fireEvent(window, 'view.zones.load.initial');

            if(isMobile == false){
                helpers.addInteractiveBrochurePopup();
            }
        }, 250); //magic number
    }

    _this.init = _init;
};